import { Component, OnInit } from "@angular/core";

import { UtilsService } from "../../../../auth/service/utils.service";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { locale as italian } from "../../../../i18n/it";
import { CertificationService } from "../../../../auth/service/certification.service";
import { AuthenticationService } from "../../../../auth/service";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { IDatatableConfig } from "app/auth/models/datatable";
import { ICertification } from "app/auth/models/certifications";

@Component({
  selector: "app-list-certifications",
  templateUrl: "./list-certifications.component.html",
  styleUrls: ["./list-certifications.component.scss"],
})
export class ListCertificationsComponent implements OnInit {
  public config: IDatatableConfig;
  public contentHeader: IContentHeader;
  public certifications: ICertification[];
  public tableLimit: number = 10;
  public searchKeyword: string = "";
  public searchStatus: number = 2;
  public currentCertification: ICertification;
  public new_certification: string = "";
  public showModalError: boolean = false;

  constructor(
    public _certificationService: CertificationService,
    public _utilService: UtilsService,
    private _routerService: Router,
    public _modalService: NgbModal,
    public _authenticationService: AuthenticationService,
    private _activatedRoute: ActivatedRoute,
  ) {
    this._utilService.disableAutoHideLoading();

    this._activatedRoute.queryParams.subscribe((params: Params) => {
      if (params.enabled && Number(params.enabled) < 3) {
        this.searchStatus = params.enabled;
      }
    });
  }

  async ngOnInit() {
    this.config = {
      selectLimitItems: true,
      headerHeight: 30,
      rowHeight: 70,
      footerHeight: 60,
      scrollbarH: true,
      searchable: true,
      exportable: false,
      columns: [
        {
          value: "name",
          text: italian.data.FIRSTNAME,
          width: 500,
          sortable: true,
        },
        {
          value: "users",
          text: italian.data.HOW_MANY_USER_CERTIFCATE,
          width: 300,
          sortable: true,
        },
        {
          value: "enabled_label",
          text: italian.data.STATE,
          width: 200,
          sortable: true,
        },
      ],
    };

    if (this._utilService.isMobile || this._utilService.isTablet) {
      this.config.columns.splice(1, 2);
      this.config.columns[0].width = null;
      this.config.scrollbarH = false;
      this.config.rowHeight = 110;
    }

    this.contentHeader = {
      headerTitle: italian.data.CERTIFICATIONS,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: italian.data.MENU.MANAGE,
            isLink: true,
            link: "/dashboard/platform-management",
          },
          {
            name: italian.data.CERTIFICATIONS,
            isLink: false,
          },
        ],
      },
    };
    await this.loadCertification();
    this._utilService.hideLoading();
  }

  updateTableLimit(event: { target: { value: string } }) {
    this.tableLimit = Number(event.target.value);
  }

  async loadCertification() {
    this.certifications = await this._certificationService.getList();
    const activeStr: string = await this._utilService.translate("ACTIVATED");
    const disableStr: string = await this._utilService.translate("TO_APPROVED");
    this.certifications.map(async (item: ICertification) => {
      if (item.enabled === 1) {
        item.enabled_label = activeStr;
      } else {
        item.enabled_label = disableStr;
      }
    });
  }

  certificationsList() {
    let items: ICertification[] = this.certifications || [];

    const keywords: string = this.searchKeyword.trim().toLowerCase();

    if (keywords.length > 0) {
      items = items.filter((item: ICertification) => item.name.toLowerCase().includes(keywords));
    }

    if (this.searchStatus < 2) {
      items = items.filter((item: ICertification) => Number(item.enabled) === Number(this.searchStatus));
    }

    return items;
  }

  async addCertification() {
    if (!this._authenticationService.hasCapability("create_certification")) {
      window.history.back();
      return false;
    }

    if (this.new_certification.length < 1) {
      this.showModalError = true;
      return false;
    }

    const data: { name: string; enabled: number } = {
      name: this.new_certification,
      enabled: 1,
    };
    this._utilService.showLoading();
    await this._certificationService
      .create(data)
      .then(async () => {
        this._modalService.dismissAll();
        this._utilService.hideLoading();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_UPLOAD_CERTIFICATE" });
        this.certifications = await this._certificationService.getList(true);
        await this.loadCertification();
      })
      .catch(() => this._utilService.showSWALError({ text: "ERROR_UPLOAD_CERTIFICATE" }));
    this.new_certification = "";
    this.showModalError = false;
    this._modalService.dismissAll();
  }

  async editCertification() {
    if (!this._authenticationService.hasCapability("edit_certification")) {
      window.history.back();
      return false;
    }

    if (this.currentCertification.name.length < 1) {
      this.showModalError = true;
      return false;
    }
    const data: { name: string } = {
      name: this.currentCertification.name,
    };
    this._utilService.showLoading();
    await this._certificationService
      .update(this.currentCertification.id, data)
      .then(() => {
        this._modalService.dismissAll();
        this._utilService.hideLoading();
        this.loadCertification();
        this._utilService.showSWALSuccess({ text: "SUCCESS_EDIT_CERTIFICATE" });
      })
      .catch(() => this._utilService.showSWALError({ text: "ERROR_EDIT_CERTIFICATE" }));
  }

  async deleteCertification(currentCertification) {
    if (!this._authenticationService.hasCapability("delete_certification")) {
      window.history.back();
      return false;
    }
    if (currentCertification.users > 0 && currentCertification.enabled !== 0) {
      await this._utilService.showSWALError({ text: "USED_CERTIFICATE_TEXT" });
      return;
    }

    let deleteText: string = await this._utilService.translate("ALERT.CONFIRM_DELETE_TEXT");
    deleteText += await this._utilService.translate("ALERT.CONFIRM_DELETE_THIS_OBJECT");
    deleteText += currentCertification.name;

    await this._utilService
      .showSWALDeleteConfirmation({ text: deleteText })
      .then(async (result) => {
        if (result.value) {
          await this._certificationService.delete(currentCertification.id);
          await this._utilService.showPopupItemDeleted().then(async () => {
            await this.loadCertification();
          });
        } else if (result.isDismissed) {
          await this._utilService.showSWALError({
            title: "ABORTED_TITLE",
            text: "ABORTED_TEXT",
          });
        }
      })
      .catch(() => this._utilService.showSWALError({ text: "ERROR_REMOVE_CERTIFICATE" }));
  }

  public modalOpen(modalBasic, currentCertification: number) {
    this._modalService.open(modalBasic, {
      size: "sm",
      centered: true,
    });
    this.new_certification = "";
    this.currentCertification = JSON.parse(JSON.stringify(currentCertification));
    this.showModalError = false;
  }

  async approve(id: number) {
    await this._utilService.showLoading();
    await this._certificationService
      .approve(id)
      .then(async () => {
        await this.loadCertification().then(async () => {
          await this._utilService.hideLoading();
          await this._utilService.showSWALSuccess({ text: "SUCCESS_APPROVE_CERTIFICATE" });
        });
      })
      .catch(async () => {
        await this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "ERROR_EDIT_CERTIFICATE" });
      });
  }

  async reject(id: number) {
    await this._utilService.showLoading();
    await this._certificationService
      .reject(id)
      .then(async () => {
        await this.loadCertification().then(async () => {
          await this._utilService.hideLoading();
          await this._utilService.showSWALSuccess({ text: "SUCCESS_REJECT_CERTIFICATE" });
        });
      })
      .catch(async () => {
        await this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "ERROR_EDIT_CERTIFICATE" });
      });
  }
}
